import React, { useEffect} from 'react';
import { getFileName } from '../../../helpers/FileCaching';
import MediaQuery from 'react-responsive';
// styles
import classes from './hero.module.scss'
//import renderHTML from 'react-render-html';
import globalJSON from '../../../data/global.json'
import hubJSON from '../../../data/hub.json';

const heroImages = require.context('../../../images/components/hero', true, /.*\.(gif|png|jpe?g|svg)$/i);
const heroData = hubJSON.hero;

function Hero({windowSize, content}){
	useEffect(() => {

	},[windowSize])
	
	return (
		<section id={"hero"} className={classes.hero}>
			<div className={classes.hero__container} style={{backgroundImage: `url(${getFileName(heroImages, heroData.backgroundImage[windowSize])})`}} title={heroData.backgroundImageAlt}>
			<MediaQuery minWidth={classes.screenXl}>
				<video src={globalJSON.videoCdn+content.backgroundVideo.desktop} muted playsInline autoPlay loop className={classes.hero__video} />
				<div className={classes.hero__title} >
					<img src={getFileName(heroImages, heroData.title)} alt={heroData.titleAlt}/>	
                </div>
				<div className={classes.hero__subtitle} >
                    <h1 className={classes.hero__subtitle_text}>{heroData.subTitle}</h1>	
                </div>
			</MediaQuery>
			
                <div className={classes.hero__title} >
					<img src={getFileName(heroImages, heroData.title)} alt={heroData.titleAlt}/>	
                </div>
				<div className={classes.hero__subtitle} >
                    <h1 className={classes.hero__subtitle_text}>{heroData.subTitle}</h1>	
                </div>
			</div>

			<div className={classes.hero__description_contianer}>
                <p className={classes.hero__description}>{heroData.description}</p>
			</div>
			
		</section>
		
	)
}

export default Hero;